export const PCM_MAX_VALUE = 9999;
